import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as PIXI from 'pixi.js'
import App from './App'

// Required by pixi-live2d-display — must be set before the library loads
window.PIXI = PIXI;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
